import React from 'react';
import PropTypes from 'prop-types';

import CreditRating from '../../../components/CreditRating';

import GroupWrapper from '../../../components/GroupWrapper';

const Page = ({ pageData }) => {
  const { data } = pageData;
  return (
    <>
      <GroupWrapper>
        <CreditRating
          table={data}
        />
      </GroupWrapper>
    </>
  );
};

Page.propTypes = {
  pageData: PropTypes.shape({
    data: PropTypes.shape({}).isRequired,
  }).isRequired,
};

export default Page;
